import {
    faCircleExclamation,
    faExclamationTriangle,
    faInfoCircle,
    faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { Severity } from "./types";

export const severity = ["info", "success", "warning", "error"] as const;

export const DEFAULT_SEVERITY = "info" satisfies Severity;

export const defaultIconMapping = {
    info: <FontAwesomeIcon icon={faInfoCircle} />,
    success: <FontAwesomeIcon icon={faCheckCircle} />,
    warning: <FontAwesomeIcon icon={faExclamationTriangle} />,
    error: <FontAwesomeIcon icon={faCircleExclamation} />,
};
